export const ACCESS_TOKEN_HEADER_NAME = 'x-auth0-authorization';
